import React, { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import * as Yup from 'yup';
import swal from 'sweetalert2';
import { Form, Input, Textarea } from '@rocketseat/unform';
import logo from '~/assets/logo_home.png';
import { Container } from './styles';
import api from '~/services/api';
import GDPRPanel from '~/components/GDPRPanel';

const schema = Yup.object().shape({
  nome_contato: Yup.string().required('O nome é obrigatório'),
  email: Yup.string().required('O e-mail é obrigatório'),
  telefone: Yup.string(),
  nome_empresa: Yup.string().required('O celular é obrigatória'),
  mensagem: Yup.string().required('A mensagem é obrigatória'),
});
function Footer() {
  const [loading, setLoading] = useState(false);

  async function handleSubmit(
    { nome_contato, email, telefone, nome_empresa, mensagem },
    { resetForm }
  ) {
    setLoading(true);

    const formData = new URLSearchParams();
    formData.append('nome_contato', nome_contato);
    formData.append('email', email);
    formData.append('telefone', telefone);
    formData.append('nome_empresa', nome_empresa);
    formData.append('mensagem', mensagem);

    const response = await api.post('contato', formData);

    if (response.data) {
      swal
        .fire('Bom Trabalho!', 'Logo entraremos em contato!', 'success')
        .then(_ => {
          resetForm();
        });
    } else {
      swal.fire(
        'Ocorreu um erro',
        'Desculpe o incômodo, mas um erro inesperado aconteceu tente novamente;',
        'error'
      );
    }
    setLoading(false);
  }
  return (
    <>
      <Container>
        <div className="container pt-5" id="contato">
          <div className="row bg-orange border-radius">
            <div className="col-12 bg-blue text-center border-radius">
              <h4 className="mb-0 py-3">DESEJO AGENDAR UM CALL!</h4>
            </div>
          </div>
        </div>
        <div className="bg-blue">
          <div className="container pt-5 pb-4">
            <Form schema={schema} onSubmit={handleSubmit}>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <div className="form-group">
                    <label htmlFor="nome_contato">NOME DO CONTATO</label>
                    <Input
                      type="name"
                      id="nome_contato"
                      className="form-control"
                      name="nome_contato"
                      aria-describedby="nome_contato"
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="form-group">
                    <label htmlFor="nome_empresa">NOME DA EMPRESA</label>
                    <Input
                      type="name"
                      id="nome_empresa"
                      className="form-control"
                      name="nome_empresa"
                      aria-describedby="nome_empresa"
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="form-group">
                    <label htmlFor="email">E-MAIL CORPORATIVO</label>
                    <Input
                      type="email"
                      id="email"
                      className="form-control"
                      name="email"
                      aria-describedby="email"
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="form-group">
                    <label htmlFor="tel">TELEFONE OU CELULAR</label>
                    <Input
                      type="tel"
                      id="tel"
                      className="form-control"
                      name="telefone"
                      aria-describedby="telefone"
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="form-group">
                    <label htmlFor="mensagem">
                      CONTE-NOS UM POUCO SOBRE O QUE SUA EMPRESA PRECISA
                    </label>
                    <Textarea
                      type="text"
                      className="form-control text-area"
                      name="mensagem"
                      aria-describedby="mensagem"
                      id="mensagem"
                      rows="4"
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <button
                    type="submit"
                    dissable={loading}
                    className="btn w-100 py-3 btn-enviar"
                    onClick={() => window.formulario_conversion()}
                    id="conversion_formb2b"
                  >
                    {loading ? (
                      <FaSpinner size={20} color="#43b0b0" className="spin" />
                    ) : (
                      'ENVIAR'
                    )}
                  </button>
                </div>
              </div>
            </Form>
            <div className="row pt-4">
              <div className="col-md-4 text-center text-md-left cliques">
                <div className="row align-itmes-center h-100">
                  <div className="col-12 ">
                    <a
                      className="d-block "
                      href="https://amzmp.com.br"
                      title="amzmp"
                    >
                      amzmp.com.br
                    </a>
                    <a
                      className="d-block"
                      href="mailto:bruno@amzmp.com.br"
                      title="E-mail"
                    >
                      bruno@amzmp.com.br
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-center">
                <img src={logo} alt="AMZ|b2b" className="w-75 my-auto" />
              </div>
              <div className="col-md-4 text-center text-md-left">
                <div className="row h-100 align-items-center flex-row-reverse">
                  <div className="col-md-9 text-white">
                    <p className="mb-0 endereco">
                      {/* (55) 11 4191.1578 */}
                      <br />
                      Al. Araguaia, 1293 | Alphaville | SP
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <p className="text-center my-2">Copyright © 2021 criação: amz|mp</p>
      <GDPRPanel />
    </>
  );
}

export default Footer;
